import axiosInstance from "./Utils/axiosInstance";

export class weekplannerDataPayload {
  static async weekPlannerData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/weekplanner",
        payload
      );
      return data
    } catch (error) {
      throw error;
    }
  }

}
